import React from 'react';
import { Navigate } from 'react-router';
import { SHOW_FILM_UPLOAD_ENTRY_POINTS } from '../utils/engineAccess';
import { lscPath } from '../lsc/routing';
import EngineAccessGuard from './EngineAccessGuard';
import Upload from './Upload';

/** Blocks /upload when film upload is disabled at build time; redirects to Stream Center. */
const UploadRouteGuard: React.FC = () => {
  if (!SHOW_FILM_UPLOAD_ENTRY_POINTS) {
    return <Navigate to={lscPath()} replace />;
  }

  return (
    <EngineAccessGuard>
      <Upload />
    </EngineAccessGuard>
  );
};

export default UploadRouteGuard;
